import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// =============================================================================
//  Copyright : 2023 semantics GmbH
//  Date      : $Date: 2026-03-13 15:47:48 +0100 (Fri, 13 Mar 2026) $
//  Author    : Olli Powroznik
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 161511 $
//  Purpose   : custom buttons
// =============================================================================
// ---Third-party imports
import React from 'react';
import clsx from 'clsx';
// ---Framework imports
import log from 'uix/logging';
import { KeyboardShortCut, Button } from 'uix/components';
import { WikiModalPortal } from 'uix/wiki/components';
import { Sel } from 'uix/registries';
import { useSelector } from 'uix/hooks';
// ---Local imports
import S from './modal.css';
// ---Exports
export const Modal = ({ caption, children, imageId, mobile, onClose, open, scrolling, controls, width = 1600, style })=>{
    let apiurl = useSelector(Sel.apiurl);
    let bgStyle = {};
    if (imageId) {
        let imgurl = `/image/pagebox/${imageId}/${width}`;
        bgStyle = {
            backgroundImage: `url(${apiurl.href(imgurl)})`
        };
    }
    let controlButtons = /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            controls,
            /*#__PURE__*/ _jsx(Button, {
                className: S.controlButtons,
                bordered: true,
                style: {
                    margin: 'auto',
                    zIndex: 30
                },
                icon: "close",
                onClick: onClose
            })
        ]
    });
    let topEls = /*#__PURE__*/ _jsx(_Fragment, {
        children: controlButtons
    });
    let bottomEls = caption ? /*#__PURE__*/ _jsx(_Fragment, {
        children: caption
    }) : null;
    return /*#__PURE__*/ _jsx(WikiModalPortal, {
        children: /*#__PURE__*/ _jsxs("div", {
            className: clsx(open && S.modal, scrolling && S.scrolling, imageId && S.bgActive, mobile && S.mobile, !topEls && S.noTop),
            style: style,
            open: true,
            children: [
                /*#__PURE__*/ _jsx(KeyboardShortCut, {
                    name: "Escape",
                    onTrigger: onClose
                }),
                topEls && /*#__PURE__*/ _jsx("div", {
                    className: S.topBar,
                    children: topEls
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: S.bgImg,
                    style: bgStyle
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: clsx(S.content, caption && S.bottom, !bottomEls && S.noBottom),
                    children: children
                }),
                bottomEls && /*#__PURE__*/ _jsx("div", {
                    className: S.bottomBar,
                    children: bottomEls
                })
            ]
        })
    });
};
